import { POSITIONS, type Position } from "../data/types";
import { t } from "../utils/i18n";

interface Props {
  value: Position;
  onChange: (p: Position) => void;
}

export function PositionSelector({ value, onChange }: Props) {
  return (
    <div className="w-full">
      <h3 className="mb-1.5 text-center text-xs font-semibold uppercase tracking-wide text-slate-600">
        {t("customScreenPosition")}
      </h3>
      <div className="grid grid-cols-3 gap-1.5">
        {POSITIONS.map((p) => {
          const active = p === value;
          return (
            <button
              key={p}
              onClick={() => onChange(p)}
              className={
                "flex h-10 w-full items-center justify-center rounded border text-sm font-semibold transition-colors " +
                (active
                  ? "border-sky-600 bg-sky-600 text-white"
                  : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50")
              }
            >
              {p}
            </button>
          );
        })}
      </div>
    </div>
  );
}
